import NavBar from './navbar-view'

export default NavBar
